import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    selector: 'app-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrl: './image-viewer.component.scss',
    standalone: false
})
export class ImageViewerComponent {

  imageUrls = [] as string[]
  currentImage!: string
  isLoad = false

  constructor(@Inject(MAT_DIALOG_DATA) public data: { images: string, foodName: string }) {
    if (data.images.includes(',')) {
      this.imageUrls = data.images.split(',');
      this.currentImage = this.imageUrls[0];
    }
  }

  onPrev() {
    this.isLoad = true;
    setTimeout(() => {
      const index = this.imageUrls.indexOf(this.currentImage);
      if (index === 0) {
        this.currentImage = this.imageUrls[this.imageUrls.length - 1];
      } else {
        this.currentImage = this.imageUrls[index - 1];
      }
      this.isLoad = false;
    }, 500);
  }

  onNext() {
    this.isLoad = true;
    setTimeout(() => {
    const index = this.imageUrls.indexOf(this.currentImage);
    if (index === this.imageUrls.length - 1) {
      this.currentImage = this.imageUrls[0];
    } else {
      this.currentImage = this.imageUrls[index + 1];
    }
      this.isLoad = false;
    }, 500);
  }
}
